module.exports = __webpack_public_path__ + "img/16.3330d8a7.png";